import { SpotUsersGroupIcon } from '@tableau/icons/SpotUsersGroupIcon';
import React from 'react';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause,ExplorableItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { GroupContentType } from '~src/spacesPlatform/models/ContentTypes';
import { Groups } from '~src/userManagement/groups/Groups';

import { getNoDefaultFilters } from '../../../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const GroupDefinition: ExplorableItemDefinition & SpaceDefinition<'group'> = {
  itemType: 'siteuser',
  contentType: 'group',
  singularName: Messages.group,
  pluralName: Messages.groups,
  emptyStateMessage: Messages.groupsEmptyMessage,
  contentFilterKeys: GroupContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconType: null,
  headerIconPath: () => imgPath('spaces_masthead_groups.svg'),
  headerIconNode: () => <SpotUsersGroupIcon size={60} alt='' />,
  filterClause: ServerFilterClauses.ContentType(['siteuser']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Groups.all();
  },
  getContentInfo: () => {
  },
  contentSpaceUrl: () => '',
  supportedDisplayModes: ['list'],
};
